module.exports = __webpack_public_path__ + "static/iphone@2x-0ca0545923ec41b50aef0edea6023ab0.png";